import { render, staticRenderFns } from "./SmsCredits.vue?vue&type=template&id=2e57d4fc&scoped=true"
import script from "./SmsCredits.vue?vue&type=script&lang=js"
export * from "./SmsCredits.vue?vue&type=script&lang=js"
import style0 from "./SmsCredits.vue?vue&type=style&index=0&id=2e57d4fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e57d4fc",
  null
  
)

export default component.exports